import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {VideoSource} from "./types";
import {ServerAPI} from "../1. Core/ServerAPI";
import TextField from "../1. Core/Controls/TextField/TextField";
import Select from "../1. Core/Controls/Select/Select";


export default class EditVideoSourceDialog extends Dialog {


    private _VideoSource: VideoSource;
    private _name: TextField;
    private _channelId: TextField;
    private _lang: Select;


    constructor(props: any) {
        super(props);
    }

    _initFields(settings: object) {
        this._VideoSource = {lang: 'en'} as VideoSource;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'VideoSource';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Name'
        });


        this._channelId = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'YoutubeChannelId'
        });

        this._lang = new Select({
            FloatingLabel: 'Status',
            ParentNode: this._contentNode,
            Value: 'sharedog',
            Items: [
                {Content: 'ru', Value: 'ru'},
                {Content: 'en', Value: 'en'},
            ]
        });

        this.refresh()
    }


    async refresh() {
        this._name.setValue(this._VideoSource.name)
        this._channelId.setValue(this._VideoSource.channelId)
        this._lang.setValue(this._VideoSource.lang)
    }


    async _onOkButtonClick() {

        this._VideoSource.name = this._name.getValue()
        this._VideoSource.channelId = this._channelId.getValue()
        this._VideoSource.lang = this._lang.getValue()

        if (this._VideoSource.id)
            await ServerAPI.post(`/video-source/${this._VideoSource.id}`, this._VideoSource)
        else
            await ServerAPI.post(`/video-source/`, this._VideoSource);


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}
